/* eslint typescript-sort-keys/string-enum: "warn", curly: "error" */

export enum ApplicationEvents {
  // Auth0 logged in and authenticated, only once per page load,
  ApplicationReady = "ApplicationReady",
  /** @deprecated In favor of promise api in authentication object (onReady, onUserAvailable) */
  UserAvailable = "UserAvailable"
}
